import type { EmotionCache } from '@emotion/cache';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';

// IMPORTANT: the `stylis` version in package.json MUST match the one pinned by
// `@emotion/cache` (currently 4.2.0). `prefixer` below runs inside Emotion's
// stylis pipeline, so if our `stylis` resolves to a different major/minor than
// Emotion's internal copy, the element/token shapes diverge and stylis throws
// "Cannot read properties of undefined (reading 'push')" at render time
// (e.g. on the survey builder toolbar). Keep the dependency pinned exact.

// Build an Emotion cache wired for the requested writing direction. For RTL
// (Arabic) the stylis RTL plugin flips physical CSS properties (margin/padding
// left↔right, text-align, etc.) so MUI components mirror correctly.
export function createEmotionCache(dir: 'ltr' | 'rtl'): EmotionCache {
  return dir === 'rtl'
    ? createCache({ key: 'mui-rtl', stylisPlugins: [prefixer, rtlPlugin] })
    : createCache({ key: 'mui', stylisPlugins: [prefixer] });
}
